import { InjectionToken } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { Element } from '../../../../equipment/models/elements/element';
import { IPlanogram } from '../../../models/planogram';

export interface DetailedElementWidgetData {
	element: Element;
	planogram: IPlanogram;
	overlayRef: OverlayRef;
	boundingRect: DOMRect;
}

export interface DetailedElementWidgetRef {
	focus: () => void;
	close: () => void;
}

export const DETAILED_ELEMENT_WIDGET_DATA = new InjectionToken<DetailedElementWidgetData>('DETAILED_ELEMENT_WIDGET_DATA');
export const DETAILED_ELEMENT_WIDGET_REF = new InjectionToken<DetailedElementWidgetRef>('DETAILED_ELEMENT_WIDGET_REF');
